module.exports = __webpack_public_path__ + "static/img/b1-4-2.ee184e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b1-4-2.png
// module id = hfik
// module chunks = 1